export const openExternalLink = (link: string, target?: '_self' | '_blank') => {
  window.open(link, target ? target : '_blank');
};

export const sleep = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
